import { supabase } from './supabase';

/**
 * Sesión administrativa sobre Supabase Auth.
 *
 * El SDK ya persiste la sesión y refresca el token por su cuenta, así que
 * aquí no se guarda ningún token a mano: hacerlo duplicaría un estado que
 * Supabase mantiene mejor y acabaría desincronizándose.
 */

/** Sesión actual, o null si no hay nadie autenticado. */
export async function getSession() {
  const { data } = await supabase.auth.getSession();
  return data.session ?? null;
}

/** ¿Hay una sesión activa? */
export async function isAuthenticated() {
  return (await getSession()) !== null;
}

/**
 * ¿El usuario autenticado está dado de alta como administrador?
 * Ser usuario de Auth no basta: hace falta una fila en `admins`.
 */
export async function isAdmin() {
  const { data, error } = await supabase.rpc('is_admin');
  if (error) return false;
  return data === true;
}

/** Cierra la sesión. */
export async function signOut() {
  await supabase.auth.signOut();
}

/** Avisa cuando la sesión cambia (login, logout, refresco, otra pestaña). */
export function onAuthChange(callback) {
  const result = supabase.auth?.onAuthStateChange?.((_event, session) => {
    callback(session ?? null);
  });
  const subscription = result?.data?.subscription || result?.subscription;
  return () => subscription?.unsubscribe?.();
}
